module.exports = __webpack_public_path__ + "static/media/location-icon.07283550.svg";